import { Button, Flex, Result } from "antd";
import { observer } from "mobx-react";
import { Link, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import appConfigStore from "../../stores/appConfigStore";
import FEATURES from "../../constants/features";

export const MissingBasicAccess = observer(() => {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="Базовый функционал недоступен."
      subTitle={appConfigStore.isOwner
        ? "Выберите подходящую подписку, чтобы продолжить работу с клиентами, сметами и заказами."
        : "Обратитесь к своему руководителю, чтобы продолжить работу в Flite."}
      extra={appConfigStore.isOwner && appConfigStore.canAccessPath("settings/features")
        ? <Flex justify="center"><Button type="primary" onClick={() => navigate("/settings/features")}>Перейти к оплате</Button></Flex>
        : undefined}
    />
  );
});

export const AccessDenied = observer(() => (
  <Result status="403" title="Нет доступа" subTitle="Этот раздел недоступен для вашей компании или роли."
    extra={appConfigStore.menuPaths.length > 0 ? <Link to="/">Перейти к доступным разделам</Link> : undefined} />
));

export const MenuRoute = observer(({ children }: { children?: React.ReactNode }) => {
  const { pathname } = useLocation();
  if (!appConfigStore.canAccessPath(pathname)) {
    // A container such as /settings may expose only an authorized child.
    const child = appConfigStore.menuPaths.find((path) => path.startsWith(`${pathname.replace(/^\/+|\/+$/g, "")}/`));
    return child ? <Navigate to={`/${child}`} replace /> : <AccessDenied />;
  }
  return <>{children ?? <Outlet />}</>;
});

export const MenuIndex = observer(() => {
  if (!appConfigStore.hasFeature(FEATURES.BASIC_ACCESS)) {
    return <MissingBasicAccess />;
  }
  const path = appConfigStore.menuPaths[0];
  return path ? <Navigate to={`/${path}`} replace /> : <AccessDenied />;
});
